/**
 * Utility functions for formatting display values
 */

/**
 * Formats ethnicity values for display
 * Converts snake_case to Title Case with special handling for known values
 */
export const formatEthnicity = (ethnicity: string): string => {
  if (!ethnicity) return '-';
  
  // Handle special cases
  const specialCases: { [key: string]: string } = {
    'hispanic_latino': 'Hispanic/Latino',
    'black_african_american': 'Black/African American',
    'white_caucasian': 'White/Caucasian',
    'american_indian_alaskan_native': 'American Indian or Alaskan Native',
    'hawaiian_pacific_islander': 'Hawaiian/Pacific Islander',
    'middle_eastern': 'Middle Eastern',
  };
  
  // Check if it's a special case first
  if (specialCases[ethnicity]) {
    return specialCases[ethnicity];
  }
  
  // Default: convert snake_case to Title Case
  return ethnicity
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

/**
 * Formats sex values for display
 * Capitalizes the first letter
 */
export const formatSex = (sex: string): string => {
  if (!sex) return '-';
  return sex.charAt(0).toUpperCase() + sex.slice(1);
};
